import React from "react";
import { rollForwardPath } from "../../Settings/constants";
import { StatusChip } from "../../Settings/GoalsSection/styles";
import { PlanLink } from "../styles";
import { PlanGoalBar } from "./PlanGoalBar";
import {
  PlanGoalHeader,
  PlanGoalMessage,
  PlanGoalMeta,
  PlanGoalName,
  PlanGoalRow as GoalRow,
} from "./styles";
import { PlanGoalRowProps } from "./types";

export const PlanGoalRow: React.FC<PlanGoalRowProps> = ({ goal, subtitle }) => {
  const { progressPercent, rollForwardGoalId } = goal;
  const hasProgress = rollForwardGoalId === null && progressPercent !== null;

  return (
    <GoalRow data-testid="plan-goal">
      <PlanGoalHeader>
        <PlanGoalName>{goal.name}</PlanGoalName>
        {goal.statusLabel && (
          <StatusChip $tone={goal.statusTone}>{goal.statusLabel}</StatusChip>
        )}
      </PlanGoalHeader>
      {hasProgress && progressPercent !== null && (
        <PlanGoalBar
          name={goal.name}
          value={progressPercent}
          color={goal.barColor}
        />
      )}
      <PlanGoalMeta>
        <span>{goal.amountText}</span>
        <span>{subtitle}</span>
      </PlanGoalMeta>
      {goal.message && <PlanGoalMessage>{goal.message}</PlanGoalMessage>}
      {rollForwardGoalId !== null && (
        <PlanLink href={rollForwardPath(rollForwardGoalId)}>
          Roll forward →
        </PlanLink>
      )}
    </GoalRow>
  );
};
